import React, { useState, useEffect } from "react";
import {
  useTable,
  useSortBy,
  usePagination,
  useGlobalFilter,
  useFilters,
} from "react-table";
import "bootstrap/dist/css/bootstrap.min.css";
import "./SopsInstanceExpandableTable.css";
import Sortdownarrow from "../../../../../Components/IconComponents/Sortdownarrow";
import Sortuparrow from "../../../../../Components/IconComponents/Sortuparrow";
import Sortingarrow from "../../../../../Components/IconComponents/Sortingarrow";
import TableHeader from "../../../../../Components/UiComponents/Table/TableHeader/TableHeader";
import { useTranslation } from "react-i18next";
import i18n from "i18next";
import { Eye } from "lucide-react";

// Default filter UI for a column
const DefaultColumnFilter = ({
  column: { filterValue, preFilteredRows, setFilter },
}) => {
  return (
    <input
      value={filterValue || ""}
      onChange={(e) => {
        setFilter(e.target.value || undefined); // undefined to remove the filter entirely
      }}
      placeholder={`Filter...`}
      style={{
        width: "100%",
        padding: "5px",
        border: "1px solid #ccc",
        borderRadius: "4px",
        marginTop: "5px",
      }}
    />
  );
};

const SopsInstanceExpandableTable = (props) => {
  const {
    columns,
    data,
    numberOfRows,
    headerTableHeadStyle = {},
    tableStyle = {},
    showRowCount = true,
    rowCount,
    tabChanger = false,
    activeTab,
    setActiveTab,
    searchData,
    setSearchData = () => { },
    enableColumnFilters = false,
    disbalePaginationFilter = false,
    disbalePaginationFilter1 = false,
    disbalePaginationFilter2 = false,
    highlightTaskIds = [],
  } = props;

  // Task instance ids to bold (navigated from View Incident → Quick Links).
  const highlightTaskSet = (highlightTaskIds || []).map((v) => String(v));
  const rowHasTaskMatch = (rowData) =>
    highlightTaskSet.length > 0 &&
    (rowData?.userTaskMapList || []).some((tk) => highlightTaskSet.includes(String(tk.id)));

  const [expandedRowIds, setExpandedRowIds] = useState({});
  const [showAttachmentModal, setShowAttachmentModal] = useState(false);
  const [selectedImages, setSelectedImages] = useState([]);

  const toggleRowExpansion = (rowId) => {
    setExpandedRowIds((prev) => {
      const isCurrentlyExpanded = !!prev[rowId];
      return isCurrentlyExpanded ? {} : { [rowId]: true };
    });
  };

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    setGlobalFilter,
    rows,
    state: { pageIndex, globalFilter, pageSize },
  } = useTable(
    {
      columns,
      data,
      defaultColumn: { Filter: DefaultColumnFilter },
      initialState: { pageIndex: 0, pageSize: numberOfRows },
    },
    useFilters,
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  const { t } = useTranslation();

  const translateNumber = (number) => {
    const numberString = number.toString();
    return i18n.t(`numbers.${numberString}`, { defaultValue: numberString });
  };

  let tempRowCount = globalFilter ? rows.length : rowCount || data.length;
  let tempPageIndex = pageIndex;
  let tempPageSize = pageSize;

  if (tempPageIndex === undefined || tempPageIndex === null) {
    tempPageIndex = 0;
  }
  if (tempRowCount === undefined || tempRowCount === null) {
    tempRowCount = 0;
  }
  if (tempPageSize === undefined || tempPageSize === null) {
    tempPageSize = 10;
  }

  const startIndex = tempPageIndex * tempPageSize + 1 || 1;
  const endIndex =
    Math.min((tempPageIndex + 1) * tempPageSize, tempRowCount) || tempRowCount;

  const translatedStartIndex = startIndex;
  const translatedEndIndex = endIndex;
  const translatedRowCount = tempRowCount;

  useEffect(() => {
    setPageSize(numberOfRows);
  }, [numberOfRows]);

  // Auto-expand any parent task whose child list contains a task instance we
  // were asked to highlight. Keyed by row index to match react-table's row.id.
  useEffect(() => {
    if (!highlightTaskSet.length || !Array.isArray(data) || data.length === 0) return;
    const toExpand = {};
    data.forEach((rowData, idx) => {
      if (rowHasTaskMatch(rowData)) toExpand[String(idx)] = true;
    });
    if (Object.keys(toExpand).length) setExpandedRowIds(toExpand);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, highlightTaskIds]);

  useEffect(() => {
    if (globalFilter) {
      const pageData = page?.map((row) => row.original);
      setSearchData(pageData ? pageData : []);
    } else {
      const pageData = rows?.map((row) => row.original);
      setSearchData(pageData ? pageData : []);
    }
  }, [globalFilter, rows]);
  const handleViewAttachment = (upload_images = []) => {
    setSelectedImages(upload_images);
    setShowAttachmentModal(true);
  };
  const renderExpandedRow = (row) => {
    const userTaskMap = row.original.userTaskMapList || [];
    const parentTaskType = row.original.taskType;

    console.log(userTaskMap, "userTaskMapuserTaskMapuserTaskMap");

    return (
      <tr>
        <td colSpan="6">
          <div
            style={{
              width: "85%",
              // border: "1px solid white",
              borderRadius: "10px",
              marginTop: "10px",
              marginLeft: "80px",
              marginBottom: "10px",
              // border: "1px solid #ddd",
            }}
          >
            <table
              style={{
                height: "5%",
                borderCollapse: "collapse",
                position: "relative",
              }}
            >
              <thead style={{ position: "sticky" }}>
                <tr style={{ backgroundColor: "#4899b7" }}>
                  <th
                    style={{
                      padding: "8px",
                      textAlign: "left",
                      borderBottom: "1px solid #ddd",
                      color: "white",
                    }}
                  >
                    {t("Assign To")}
                  </th>
                  <th
                    style={{
                      padding: "8px",
                      textAlign: "left",
                      borderBottom: "1px solid #ddd",
                      color: "white",
                    }}
                  >
                    {t("Task Name")}
                  </th>
                  <th
                    style={{
                      padding: "8px",
                      textAlign: "left",
                      borderBottom: "1px solid #ddd",
                      color: "white",
                    }}
                  >
                    {t("Updated On")}
                  </th>
                  <th
                    style={{
                      padding: "8px",
                      textAlign: "left",
                      borderBottom: "1px solid #ddd",
                      color: "white",
                    }}
                  >
                    {t("Action Message")}
                  </th>
                  <th style={{
                    padding: "8px",
                    textAlign: "left",
                    borderBottom: "1px solid #ddd",
                    color: "white",
                  }}>
                    {t("View Attachment")}
                  </th>
                  <th
                    style={{
                      padding: "8px",
                      textAlign: "left",
                      borderBottom: "1px solid #ddd",
                      color: "white",
                    }}
                  >
                    {t("Status")}
                  </th>
                  <th
                    style={{
                      padding: "8px",
                      textAlign: "left",
                      borderBottom: "1px solid #ddd",
                      color: "white",
                    }}
                  >
                    {t("Priority")}
                  </th>
                </tr>
              </thead>
              <tbody>
                {userTaskMap.map((task) => {
                  const isTaskMatch =
                    highlightTaskSet.length > 0 && highlightTaskSet.includes(String(task.id));
                  return (
                  <tr
                    key={task.id}
                    style={isTaskMatch ? { background: "#e2e8f0", fontWeight: 700, color: "#1e293b" } : {}}
                  >
                    <td
                      style={{
                        padding: "10px",
                        textAlign: "left",
                        borderBottom: "1px solid gray",
                      }}
                    >
                      {task.user_name || t("NA")}
                    </td>
                    <td
                      style={{
                        padding: "10px",
                        textAlign: "left",
                        borderBottom: "1px solid gray",
                      }}
                    >
                      {task.task_name || t("NA")}
                    </td>
                    {/* <td
                      style={{
                        padding: "8px",
                        textAlign: "left",
                        borderBottom: "1px solid gray",
                      }}
                    >
                      {task.description || t("NA")}
                    </td> */}
                    <td
                      style={{
                        padding: "8px",
                        textAlign: "left",
                        borderBottom: "1px solid gray",
                      }}
                    >
                      {task.updated_on
                        ? new Date(task.updated_on).toLocaleString("en-GB", {
                          day: "2-digit",
                          month: "2-digit",
                          year: "numeric",
                          hour: "2-digit",
                          minute: "2-digit",
                          hour12: true,
                        })
                        : task.created_on
                          ? new Date(task.created_on).toLocaleString("en-GB", {
                            day: "2-digit",
                            month: "2-digit",
                            year: "numeric",
                            hour: "2-digit",
                            minute: "2-digit",
                            hour12: true,
                          })
                          : t("NA")}
                    </td>
                    <td
                      style={{
                        padding: "10px",
                        textAlign: "left",
                        borderBottom: "1px solid gray",
                      }}
                    >
                      {task.description || t("NA")}
                    </td>
                    <td style={{
                      padding: "10px",
                      textAlign: "center",
                      borderBottom: "1px solid gray",
                    }}>
                      {task.images &&
                        task.images.length > 0 ? (
                        <span
                          style={{
                            cursor: "pointer",
                            fontSize: "18px",
                            color: "#18a3a0",
                          }}
                          onClick={() =>
                            handleViewAttachment(task.images)
                          }
                          title="View Attachment"
                        >
                         <Eye size={18} />
                        </span>
                      ) : (
                        t("NA")
                      )}
                    </td>
                    <td
                      style={{
                        padding: "10px",
                        textAlign: "left",
                        borderBottom: "1px solid gray",
                      }}
                    >
                      {task.status_code
                        ? (() => {
                          const statusMap = {
                            TASK_EXE_STATUS_NEW_TASK: {
                              color: "#B2EAFE",
                              label:
                                parentTaskType === "341" ||
                                  task.parent_task_type === "341"
                                  ? t("Started")
                                  : parentTaskType === "340" ||
                                    task.parent_task_type === "340"
                                    ? t("New Message")
                                    : t("Started"),
                            },
                            TASK_EXE_STATUS_INPROGRESS: {
                              color: "#fccd7c",
                              label: t("In Progress"),
                            },
                            TASK_EXE_STATUS_COMPLETED: {
                              color: "#7cdb90",
                              label:
                                parentTaskType === "341" ||
                                  task.parent_task_type === "341"
                                  ? t("Completed")
                                  : parentTaskType === "340" ||
                                    task.parent_task_type === "340"
                                    ? t("Acknowledged")
                                    : t("Completed"),
                            },
                            TASK_EXE_STATUS_CANCEL: {
                              color: "#e95060",
                              label: t("Canceled"),
                            },
                            TASK_EXE_STATUS_CLOSED: {
                              color: "Gray",
                              label: t("Closed"),
                            },
                          };

                          const status = statusMap[task.status_code];

                          return status ? (
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "6px",
                              }}
                            >
                              <span
                                style={{
                                  width: "8px",
                                  height: "8px",
                                  backgroundColor: status.color,
                                  borderRadius: "50%",
                                }}
                              ></span>
                              <span style={{ color: "inherit" }}>
                                {status.label}
                              </span>{" "}
                              {/* Label remains default color */}
                            </div>
                          ) : (
                            task.status_name || t("NA")
                          );
                        })()
                        : task.status_name || t("NA")}
                    </td>
                    <td
                      style={{
                        padding: "10px",
                        textAlign: "left",
                        borderBottom: "1px solid gray",
                      }}
                    >
                      {(() => {
                        const priorityMap = {
                          0: { color: "#b2eafe", label: t("Low") }, // Green
                          1: { color: "#fccd7c", label: t("Medium") }, // Yellow
                          2: { color: "#e87c86", label: t("High") }, // Red
                        };

                        const priority =
                          priorityMap[task.priority] || priorityMap[0]; // Default to "Low"

                        return (
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "6px",
                            }}
                          >
                            <span
                              style={{
                                width: "8px",
                                height: "8px",
                                backgroundColor: priority.color,
                                borderRadius: "50%",
                              }}
                            ></span>
                            <span style={{ color: "inherit" }}>
                              {priority.label}
                            </span>{" "}
                            {/* Text remains default color */}
                          </div>
                        );
                      })()}
                    </td>
                  </tr>
                  );
                })}
              </tbody>
            </table>

          </div>
        </td>
      </tr>
    );
  };

  return (
    <div className="tabl_container">
      <div
        style={{
          fontSize: "12pt",
          marginLeft: "15px",
          marginTop: "1rem",
          marginBottom: "1rem",
          color: "#17a3a0",
          fontSize: "17px",
          fontWeight: "700px"
        }}
      >
        Task List
      </div>
      <div className="iccc__table--container" style={tableStyle}>
        <table {...getTableProps()} className="table iccc--table">
          <thead style={{ backgroundColor: "#4899b7" }}>
            <tr>
              <th
                style={{
                  width: "30px",
                  textAlign: "left",
                  color: "white",
                  backgroundColor: "#18a3a0",
                }}
              >
                {t("")}
              </th>
              {headerGroups.map((headerGroup, index) => (
                <React.Fragment key={index}>
                  {headerGroup.headers.map((column, index) => (
                    <th
                      {...column.getHeaderProps(column.getSortByToggleProps())}
                      style={headerTableHeadStyle}
                      key={index}
                    >
                      {column.render("Header")}
                      {!column.disableSortBy &&
                        (column.isSorted ? (
                          column.isSortedDesc ? (
                            <Sortdownarrow />
                          ) : (
                            <Sortuparrow />
                          )
                        ) : (
                          <Sortingarrow />
                        ))}
                      {enableColumnFilters && column.canFilter && (
                        <div>{column.render("Filter")}</div>
                      )}
                    </th>
                  ))}
                </React.Fragment>
              ))}
            </tr>
          </thead>
          <tbody {...getTableBodyProps()}>
            {page.length > 0 ? (
              page.map((row, i) => {
                prepareRow(row);
                const isExpanded = expandedRowIds[row.id];
                const isHighlighted = rowHasTaskMatch(row.original);
                const highlightCellStyle = isHighlighted
                  ? { background: "#e2e8f0", fontWeight: 700, color: "#1e293b" }
                  : {};

                return (
                  <React.Fragment key={row.id}>
                    <tr
                      {...row.getRowProps()}
                      style={isHighlighted ? { borderLeft: "3px solid #475569" } : {}}
                    >
                      <td style={{ textAlign: "left", ...highlightCellStyle }}>
                        <span
                          onClick={() => toggleRowExpansion(row.id)}
                          style={{ cursor: "pointer", fontSize: "18px" }}
                        >
                          {isExpanded ? "-" : "+"}
                        </span>
                      </td>
                      {row.cells.map((cell) => (
                        <td
                          {...cell.getCellProps()}
                          key={cell.column.id}
                          style={{ textAlign: "left", ...highlightCellStyle }}
                        >
                          {cell.render("Cell")}
                        </td>
                      ))}
                    </tr>
                    {isExpanded && renderExpandedRow(row)}
                  </React.Fragment>
                );
              })
            ) : (
              <tr>
                <td colSpan={columns.length + 1} className="no-data-text">
                  No data Found
                </td>
              </tr>
            )}
          </tbody>
        </table>
        {showAttachmentModal && (
          <div className="attachment-modal-backdrop">
            <div className="attachment-modal">
              <div className="modal-header">
                <h5>{t("View Attachments")}</h5>
                <button
                  onClick={() => setShowAttachmentModal(false)}
                  className="close-btn"
                >
                  ✖
                </button>
              </div>

              <div className="image-grid" style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                gap: '15px',
                padding: '15px',
                maxHeight: '500px',
                overflowY: 'auto'
              }}>
                {selectedImages.map((img, index) => (
                  <div key={index} style={{
                    border: '1px solid #ddd',
                    borderRadius: '8px',
                    padding: '5px',
                    backgroundColor: '#f9f9f9'
                  }}>
                    <img
                      src={img}
                      alt={`Attachment ${index + 1}`}
                      style={{
                        width: '100%',
                        height: '200px',
                        objectFit: 'contain',
                        borderRadius: '4px'
                      }}
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}

      </div>

      <div className="d-flex justify-content-between align-items-center">
        {!disbalePaginationFilter2 && (
          <div className="float-start m-2 mt-2 ms-3">
            {showRowCount && (
              <div className="float-start m-2 mt-1 ms-3 pagecount-style">
                {t("showingentriestable.showing")} {translatedStartIndex}{" "}
                {t("showingentriestable.to")} {translatedEndIndex}{" "}
                {t("showingentriestable.of")} {translatedRowCount}{" "}
                {t("showingentriestable.entries")}
              </div>
            )}
          </div>
        )}
        <div className="pagination">
          {!disbalePaginationFilter && (
            <div className="d-flex">
              <span className="pagination_gotopage">
                Go to page:
                <input
                  type="number"
                  min="1"
                  defaultValue={pageIndex + 1}
                  onChange={(e) => {
                    let pageNumber = Number(e.target.value);
                    if (pageNumber < 1 || isNaN(pageNumber)) {
                      pageNumber = 1; // Ensures minimum value of 1
                    }
                    gotoPage(pageNumber - 1);
                  }}
                  className="pagination_gotopage-input"
                />
              </span>
              <span>
                <select
                  className="pagination_select"
                  value={pageSize}
                  onChange={(e) => setPageSize(Number(e.target.value))}
                >
                  {[10, 50, 100, 500, 1000, 2000].map((pageSize) => (
                    <option key={pageSize} value={pageSize}>
                      show {pageSize}
                    </option>
                  ))}
                </select>
              </span>
            </div>
          )}
          {!disbalePaginationFilter1 && (
            <>
              <button
                className="pagebtn mx-2"
                onClick={() => previousPage()}
                disabled={!canPreviousPage}
              >
                {"<"}
              </button>
              <button className="pagination_page">
                {translateNumber(pageIndex + 1)}{" "}
              </button>
              <button
                className="pagebtn"
                onClick={() => nextPage()}
                disabled={!canNextPage}
              >
                {">"}
              </button>{" "}
              <span className="right_pageno">
                {t("pagination.page_of", {
                  page: translateNumber(pageIndex + 1),
                  total: translateNumber(pageOptions.length),
                })}
              </span>
            </>
          )}
        </div>
      </div>

    </div>
  );
};

export default SopsInstanceExpandableTable;
